import { render, staticRenderFns } from "./ToggleCustomerActiveBtn.vue?vue&type=template&id=cce1be22&scoped=true&"
import script from "./ToggleCustomerActiveBtn.vue?vue&type=script&lang=js&"
export * from "./ToggleCustomerActiveBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cce1be22",
  null
  
)

export default component.exports